import TRANSLATIONS from './json/sv_SE_translations.json'

const TRANSLATIONS_SV_SE = {
  'checkout_shipping.pOBoxWarningText': `${window.appConfig?.pOBoxWarningText}`,
  'shopping_cart_details.hoverToZoom': 'Håll markören över för att zooma',
  'shopping_cart_details.tapToZoom': 'Tryck för att zooma',
  'coupon_code.page_link': 'noOffersPagePresent',
  'order_summary.your_promos' : 'Din rabatter',
  'shopping_cart_details.editImprint': 'Redigera tryck',
  'shopping_cart_details.clickToZoom': 'Klicka för att zooma',
  'shopping_cart_details.ships_within_msg': 'Skickas inom [X] arbetsdagar',
  'shopping_cart_details.item_total': 'Totalsumma för artikel:',
  'shopping_cart_details.each': '[X] styck',
  'shopping_cart_details.see_more': 'Se Mer',
  'shopping_cart_details.see_less': 'Se Mindre',
  'order_confirmation.cartToOrderFailureMessage' : 'Din beställning kommer att bekräftas inom kort.',
  'checkout_payment.paymentErrorTitle': 'Betalningsfel',
  'checkout_payment.paymentErrorMessage': 'Prova att ange dina betalningsuppgifter på nytt. Om problemet kvarstår, kontakta vår kundtjänst för hjälp.',
  'checkout_payment.empty_string': '',
  'checkout_payment.credit_debit': 'Kredit/debet',
  'checkout_payment.card_number': 'Kortnummer*',
  'checkout_payment.expiration_mm_yy': 'MM/ÅÅ*',
  'checkout_payment.cvv': 'CVV*',
  'checkout_payment.name_on_card': 'Namn på kort*',
  'checkout_payment.check_cc_try_again': 'Kontrollera kortnumret och försök igen.',
  'checkout_payment.check_date_try_again': 'Kontrollera datumet och försök igen.',
  'checkout_payment.check_code_try_again': 'Kontrollera koden och försök igen.',
  'checkout_payment.enter_holder_name': 'Ange namnet på ditt kort.',
  'checkout_payment.enter_cc_number': 'Ange kortnumret.',
  'checkout_payment.enter_expiration_date': 'Ange utgångsdatumet.',
  'checkout_payment.enter_cvv': 'Ange säkerhetskoden.',
  'checkout_payment.paypal_pay_later': 'PayPal Betala senare',
  'checkout_payment.continue_will_open_paypal_account_msg': 'När du fortsätter kommer du till ditt PayPal-konto.',
  'checkout_payment.continue_will_open_google_pay_account_msg': 'När du fortsätter kommer du till Google Pay.',
  'checkout_payment.paypal': 'PayPal',
  'checkout_payment.pay_by_invoice': 'Betala med faktura',
  'checkout_payment.buy_now_pay_later_info_msg': 'Köp nu och betala senare! Vi skickar en faktura när din beställning är på väg.',
  'checkout_payment.learn_more': 'Mer info',
  'checkout_payment.payment_due_late_fee_info_msg': 'Betalningen ska ske när du mottar fakturan. Sen betalning kan medföra avgifter.',
  'shopping_cart_details.unit': 'styck',
  'shopping_cart_details.editModalSaving': `Du sparar`,
  'shopping_cart_details.editModalMin_QtyWarning': `Tyvärr är det lägre än vårt minimiantal. Kontakta oss om du vill göra en mindre beställning.`,
  'shopping_cart_details.editModalMax_QtyWarning': `Tyvärr är det högre än vårt maxantal. Kontakta oss om du vill göra en större beställning.`,
  'product_details.price':'Pris',
  'product_details.edit_quantity':'Ändra antal',
  'myaccount_order_details.seeDetails': 'Visa information',
  'myaccount_order_details.viewOrderDetails': 'Se beställningsuppgifter',
  'myaccount_order_details.payMyInvoice': 'Betala fakturan',
  'myaccount_order_details.buyItAgain': 'Köp igen',
  'myaccount_order_details.viewImprint': 'Visa tryck',
  'myaccount_order_details.viewArtwork': 'Se design',
  'myaccount_order_details.productDetails': 'Produktinformation',
  'myaccount_order_details.orders': 'beställningar',
  'my_account_order_details.shipping_and_billing_addresses': 'Leverans- och faktureringsadresser',
  'my_account_order_details.log_in_to_view' : 'Logga in för att se',
  'error.use_of_old_password': 'Lösenordet måste skilja sig från dina fem tidigare lösenord.',
  'order_confirmation.postCheckout_signIn':`Logga in för fler fördelar`,
  'order_confirmation.postCheckout_accountCreation':'`Registrera dig för fler fördelar',
  'order_confirmation.postCheckout_trackOrder':'Spåra enkelt din beställning',
  'order_confirmation.would_you_like_to':'Få specialrabatter och gratisprover när du registrerar dig för erbjudanden via e-post och sms från Pens.com!',
  'order_confirmation.sign_up.contact_agreement1':'Ja',
  'order_confirmation.sign_up.contact_agreement2':', jag älskar erbjudanden!',
  'order_confirmation.sign_up.contact_disagreement1':'Nej',
  'order_confirmation.sign_up.contact_disagreement2':' tack',
  'create_account.title':'Skapa konto',
  'order_confirmation.sign_in.title':'Logga in på ditt konto',
  'order_confirmation.my_acc.title':'Mitt konto',
  'order_confirmation.addPassword':'Lägg bara till ett lösenord:',
  'order_confirmation.accountCreated':'Konto skapat',
  'myaccount_address_list.shippingAddresses': 'Leveransadresser',
  'myaccount_address_list.billingAddresses': 'Fakturaadresser',
  'myaccount_address_list.defaultAddress': 'Standardadress',
  'myaccount_address_list.setDefault': 'Ange som standard',
  'myaccount_delete_address.delete_confirmation': 'Radera bekräftelse',
  'myaccount_delete_address.confirmation_message': 'Är du säker på att du vill radera den här adressen?',
  'myaccount_delete_address.delete_address': 'Radera adress',
  'myaccount_delete_address.delete': 'Radera',
  'myaccount_error_new_password.complexity':"Det nya lösenordet måste innehålla: en siffra, ett specialtecken [!#$%&'*+-/=?^_`{|}~.@] och stora och små bokstäver.",
  'myaccount_error_confirm_password.complexity':"Det bekräftade lösenordet måste innehålla: en siffra, ett specialtecken [!#$%&'*+-/=?^_`{|}~.@] och stora och små bokstäver.",
  'myaccount_error_new_password.common_password':'Det nya lösenordet får inte vara detsamma som din e-postadress.',
  'myaccount_error_confirm_password.common_password':'Det bekräftade lösenordet får inte vara detsamma som din e-postadress.',
  'myaccount.change_personal_information.change_password_info' : 'Du kommer att loggas ut från alla aktiva enheter.',
  'validation.password_validation_heading' : 'Lösenordet måste innehålla:',
  'validation.password_validation_uppercase' : 'En versal',
  'validation.password_validation_lowercase' : 'En gemen',
  'validation.password_validation_symbol' : 'Ett specialtecken',
  'validation.password_validation_number' : 'En siffra',
  'validation.password_validation_length' : 'Minst 8 tecken',
  'validation.password_validation_match' : 'Lösenorden måste stämma överens',
  'validation.password_min_characters': 'Lösenordet måste bestå av minst 8 tecken.',
  'myaccount_password_settings.heading' : 'Inställningar för lösenord',
  'myaccount_password_settings.newPassword' : 'Nytt lösenord',
  'myaccount_password_settings.confirmPassword' : 'Bekräfta lösenord',
  'myaccount_password_settings.updatePassword' : 'Uppdatera lösenord',
  'myaccount_password_settings.createPassword' : 'Skapa lösenord',
  'myaccount_password_settings.use_of_old_password': 'Lösenordet måste skilja sig från dina senaste fem lösenord.',
  'order_details.payment_mode_apple_pay' : 'Apple Pay',
  'order_details.payment_mode_google_pay' : 'Google Pay',
  'order_details.payment_mode_ideal' : 'iDEAL',
  'order_details.payment_mode_bancontact' : 'Bancontact',
  'order_details.payment_mode_klarna' : 'Klarna',
  'dashboard.edit' : 'Redigera',
  'dashboard.greeting':'Hej!',
  'myaccount_personal_info.save_changes' : 'Spara ändringar',
  'myaccount_personal_info.cancel' : 'Avbryt',
  'myaccount_personal_info.name_title' : 'Namn',
  'myaccount_personal_info.password_title' : 'Lösenord',
  'myaccount_personal_info.add_name' : 'Lägg till namn',
  'myaccount_personal_info.edit_name' : 'Redigera namn',
  'myaccount_personal_info.name_updated' : 'Namn uppdaterat.',
  'myaccount.something_went_wrong': 'Något gick fel. Försök igen.',
  'checkout.reorder.buy_it_again':'Beställ igen',
  'checkout.reorder.purchased':'Köpt',
  'checkout.reorder.last_qty':'Senast beställda antal',
  'checkout.reorder.ships_within_msg':'Skickas inom [X] arbetsdagar',
  'checkout.reorder.add_to_cart': 'Lägg till i kundvagn',
  'checkout_payment.klarna_text' : 'Klarna',
  'checkout_payment.klarna_continue_text': 'När du fortsätter kommer du till ditt Klarna-konto.',
  'shopping_cart_details.add_accessory': 'Lägg till ett tillbehör',
  'shopping_bag.expired_discount_coupon':'Rabattkoden du har angett har gått ut. Ange en annan rabattkod.',
  'shopping_bag.invalid_discount_coupon':'Rabattkoden du har angett är inte giltig. Ange en annan rabattkod.',
  'order_summary.oops_error': 'Hoppsan! Det verkar som att något har gått fel hos oss! Försök igen.',
  'order_summary.one_promo_at_a_time': 'Endast en rabattkod kan användas åt gången.',
  'order_summary.code_applied': 'Koden har aktiverats',
  'order_summary.change_promo': 'Ändra rabattkod',
  'order_summary.your_promo_code': 'Dina rabattkoder',
  'order_summary.no_items_eligible': 'Inga varor i din kundvagn är kvalificerade för denna rabattkod.',
  'shopping_cart_details.add_amount': 'Handla för [X] till för att låsa upp erbjudandet',
  'order_details.production_time_begin_msg': '*Produktionstiden startar när beställningen har bekräftats och eventuellt bildmaterial godkänts',
  'order_details.reorder_tat': 'Efterbeställningar skickas inom X arbetsdagar*',
  'import_charge_title':'Importavgift',
  'import_charge_description':'Nyligen införda importavgifter har påverkat prissättningen på våra produkter. Vi jobbar på att dämpa påverkan av prisökningarna på våra kunder.',
  'gdpr.heading' : 'Kontot har skapats. Välkommen!',
  'gdpr.subheading' : 'Ditt konto har skapats med e-postadressen:',
  'gdpr.promotion': 'Få specialrabatter och gratisprover när du prenumererar på e-posterbjudanden från Pens.com!',
  'gdpr.yesDeal' : 'Ja, jag älskar bra erbjudanden!',
  'gdpr.noDeal' : 'Nej tack!',
  'gdpr.button' : 'Fortsätt',
  'new_activation.head' : 'Titta i din e-post!',
  'new_activation.sub_head' : 'Hej!',
  'new_activation.main_body1' : 'Tack för att du har registrerat dig hos Pens.com',
  'new_activation.main_body2' : 'En aktiveringslänk skickas till din registrerade e-postadress',
  'new_activation.main_body3' : 'Du kan inte logga in förrän ditt konto har aktiverats. Klicka på aktiveringslänken för att aktivera ditt konto.',
  'myaccount_personal_info.password_not_set' : 'Inget lösenord har angetts för det här kontot.',
  'myaccount_personal_info.click_here' : 'Klicka här',
  'myaccount_personal_info.to_reset_password' : 'för att skapa ett nytt lösenord.',
  'myaccount_personal_info.note' : 'Obs! Denna åtgärd kommer att logga ut dig från alla aktiva sessioner.',
  'oos.item_out_of_stock': 'Varan finns inte lager just nu.',
  'oos.view_similar': 'Se liknande produkter',
  'oos.similar_products': 'Liknande produkter',
  'oos.remove_out_of_stock_items': 'Du behöver tyvärr ta bort varor som inte finns i lager ur kundvagnen.',
  'oos.one_or_more_items_removed_from_cart': 'En eller flera storlekar finns inte i lager och har tagits bort från den här varan.',
  'oos.go_back_to_review': 'Gå tillbaka till kundvagnen för att granska',
  'oos.go_back_to_remove': 'Gå tillbaka till kundvagnen för att ta bort vara',
  'oos.out_of_stock': 'Ej i lager',
  'moq.lineItem_warning': 'Antalet du vill beställa är lägre än minimiantalet för denna artikel.',
  'moq.edit_qantity_link_text': 'Välj ett annat antal.',
  'moq.cart_level_warning': 'Uppdatera antalet i din beställning för att gå till kassan.',
  'moq.go_back_to_cart': 'Gå tillbaka till kundvagnen för att välja nytt beställningsantal',
  ...TRANSLATIONS
};
export default TRANSLATIONS_SV_SE;